<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.7733 1.85178C12.8257 1.90403 12.8672 1.9661 12.8956 2.03444C12.9239 2.10278 12.9385 2.17604 12.9385 2.25003C12.9385 2.32402 12.9239 2.39728 12.8956 2.46562C12.8672 2.53396 12.8257 2.59603 12.7733 2.64828L6.4204 9.00003L12.7733 15.3518C12.8789 15.4574 12.9382 15.6007 12.9382 15.75C12.9382 15.8994 12.8789 16.0427 12.7733 16.1483C12.6677 16.2539 12.5244 16.3132 12.375 16.3132C12.2257 16.3132 12.0824 16.2539 11.9768 16.1483L5.22678 9.39828C5.1744 9.34603 5.13283 9.28395 5.10448 9.21562C5.07612 9.14728 5.06152 9.07402 5.06152 9.00003C5.06152 8.92604 5.07612 8.85278 5.10448 8.78444C5.13283 8.7161 5.1744 8.65403 5.22678 8.60178L11.9768 1.85178C12.029 1.7994 12.0911 1.75783 12.1594 1.72948C12.2278 1.70112 12.301 1.68652 12.375 1.68652C12.449 1.68652 12.5223 1.70112 12.5906 1.72948C12.659 1.75783 12.721 1.7994 12.7733 1.85178Z"
      fill="#9AA5B0"
    />
  </svg>
</template>
<script>
export default {};
</script>
<style></style>
